// extracted by css-extract-rspack-plugin
export default {"container":"xacWH0O_9rkmgLiu","icon":"oF3pB1NAzdcsj8c4"};